import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { useTranslation } from "react-i18next";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";

const CashboxesDetailMain = () => {
  const {t} = useTranslation()
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("Description")} fieldName={"description"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
        <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("CreaetedDate")} fieldName="createdDate"/>
        </Col>
      </Row>
    </>
  );
};

export default CashboxesDetailMain;
